import { useEffect } from 'react';

export const useBsp = ctxData => {
  useEffect(() => {
    if (!ctxData) {
      return;
    }

    const body = document.getElementsByTagName('body')[0];
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', ctxData.BSP_SCRIPT_URL);
    script.setAttribute('data-syndicated-url', ctxData.BSP_SYNDICATE_URL);
    script.setAttribute('data-sothebys-component-loader', 'loader');
    body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [ctxData]);

  return null;
};
